export const PREMIUM_ALI_GEOCOMM = 'ALI_GEOCOMM';
export const PREMIUM_ALI_INDIGITAL = 'ALI_INDIGITAL';
export const PREMIUM_ESRI_MAP = 'ESRI_MAP';
export const PREMIUM_GIS_SERVICES = 'GIS_SERVICES';
export const PREMIUM_GIS_SEARCH = 'GIS_SEARCH';
export const PREMIUM_MAP_MARKUP = 'MAP_MARKUP';
export const PREMIUM_EAGLEVIEW = 'EAGLEVIEW';
export const MANAGE_COMMUNICATION = 'MANAGE_COMMUNICATION';
export const MANAGE_KEYWORDS = 'MANAGE_KEYWORDS';
export const HARMONY_PORTAL_CHAT_PERMISSION = 'HARMONY_PORTAL_CHAT';
export const ADMIN_LINE_REQUESTS_PERMISSION = 'ADMIN_LINE_REQUESTS';
export const AIR_AMBULANCE_PERMISSION = 'AIR_AMBULANCE';
export const TF911_PERMISSION = 'TEXT_FROM_911';
export const DISCREPANCY_REPORTING_PERMISSION = 'DISCREPANCY_REPORTING';
export const INTERAGENCY_CHAT_PERMISSION = 'INTERAGENCY_CHAT';
